// externals
import styled from 'styled-components';
import { rem } from 'polished';

export const DiagnosticWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${rem(8)} ${rem(16)};
    align-items: center;
    margin-bottom: ${rem(16)};
`;

export const DiagnosticCaption = styled.div`
    margin-top: ${rem(4)};
`;

export const DiagnosticResult = styled.div`
    overflow-wrap: anywhere;
`;
